import React, { useEffect, useState, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon from "../assets/icons/marker.png";

const customIcon = L.icon({
  iconUrl: markerIcon,
  iconSize: [40, 40],
  iconAnchor: [20, 40],
  popupAnchor: [0, -35],
});

const MapaColonias = () => {
  const [colonias, setColonias] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [mostrarLista, setMostrarLista] = useState(false);
  const [mapa, setMapa] = useState(null);
  const buscadorRef = useRef(null); // Referencia para detectar clics fuera del buscador

  const MAPA_API_URL = process.env.REACT_APP_BACKEND_URL + "/colonias/colonias/mapa/colonias";
  const TOKEN = localStorage.getItem("token");

  useEffect(() => {
    fetch(MAPA_API_URL, {
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        const coloniasConCoordenadas = data.filter(
          (colonia) => colonia.latitude !== null && colonia.longitude !== null
        );
        setColonias(coloniasConCoordenadas);
      })
      .catch((error) => console.error("Error cargando las colonias:", error));
  }, []);

  useEffect(() => {
    if (colonias.length === 0) return;

    const mapInstance = L.map("map", {
      zoomControl: true,
      scrollWheelZoom: true,
      dragging: true,
      minZoom: 12,
      maxZoom: 18,
      wheelPxPerZoomLevel: 120,
    }).setView([39.207, -2.16038], 14);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
    }).addTo(mapInstance);

    colonias.forEach((colonia) => {
      L.marker([colonia.latitude, colonia.longitude], { icon: customIcon })
        .addTo(mapInstance)
        .bindPopup(
          `<div style="font-size:14px; font-weight:bold; text-align:center;">
            ${colonia.nombre}
          </div>
          <div style="font-size:12px; text-align:center;">
            ${colonia.ubicacion || "Ubicación no disponible"}
          </div>`
        );
    });

    setMapa(mapInstance);

    return () => {
      mapInstance.remove();
    };
  }, [colonias]);

  // 🔍 Manejador de búsqueda
  const handleBuscarColonia = (e) => {
    setBusqueda(e.target.value);
    setMostrarLista(true);
  };

  // 📌 Seleccionar una colonia y ocultar la lista
  const seleccionarColonia = (colonia) => {
    if (mapa) {
      mapa.setView([colonia.latitude, colonia.longitude], 16);
    }
    setBusqueda(""); // 🔥 Limpia el campo de búsqueda
    setMostrarLista(false); // 🔥 Oculta la lista de resultados
  };

  // 🖱️ Mostrar la lista al hacer clic en el input
  const handleClickEnBuscador = () => {
    setMostrarLista(true);
  };

  // 🖱️ Cerrar la lista si el usuario hace clic fuera del buscador
  useEffect(() => {
    const manejarClicFuera = (event) => {
      if (buscadorRef.current && !buscadorRef.current.contains(event.target)) {
        setMostrarLista(false);
      }
    };
    document.addEventListener("mousedown", manejarClicFuera);
    return () => {
      document.removeEventListener("mousedown", manejarClicFuera);
    };
  }, []);

  return (
    <div className="container mt-4">
      {/* 🔹 Título centrado y negro */}
      <h1 className="text-center fw-bold text-dark mb-4">Mapa de Colonias</h1>

      {/* Contenedor del Mapa con Buscador */}
      <div className="card shadow-lg border-0 rounded position-relative" style={{ overflow: "hidden" }}>
        {/* 🔍 Buscador dentro del mapa */}
        <div
          className="position-absolute top-0 start-50 translate-middle-x mt-3 p-2 bg-white shadow rounded"
          style={{ zIndex: 1000, width: "60%", maxWidth: "400px" }}
          ref={buscadorRef}
        >
          <input
            type="text"
            className="form-control"
            placeholder="Buscar colonia..."
            value={busqueda}
            onChange={handleBuscarColonia}
            onClick={handleClickEnBuscador} // 🔥 Muestra la lista al hacer clic
          />
          {mostrarLista && (
            <ul className="list-group mt-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
              {colonias
                .filter((colonia) => colonia.nombre.toLowerCase().includes(busqueda.toLowerCase()))
                .map((colonia) => (
                  <li key={colonia.id} 
                      className="list-group-item list-group-item-action"
                      onClick={() => seleccionarColonia(colonia)}
                      style={{ cursor: "pointer" }}>
                    {colonia.nombre}
                  </li>
                ))}
            </ul>
          )}
        </div>

        {/* Mapa */}
        <div id="map" style={{ height: "70vh", width: "100%" }}></div>
      </div>
    </div>
  );
};

export default MapaColonias;
